import { render, staticRenderFns } from "./type-disolement.vue?vue&type=template&id=3fb04964"
import script from "./type-disolement.vue?vue&type=script&lang=js"
export * from "./type-disolement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports